module.exports = __webpack_public_path__ + "media/images/home-banners/california-1751455_1920-f5242d78358c043bfc185d4af4199e09.jpg";